import angular from 'angular';

angular
  .module('cxTranslations')
  .controller('TranslateLabelsCtrl', [
    'translateSvc',
    'flySvc',
    'localStorageService',
    translateLabelsCtrl,
  ]);

function translateLabelsCtrl(translateSvc, flySvc, localStorageService) {
  var vm = this;
  vm.fNotTranslated = true;
  vm.fInvalidKeys = false;
  vm.showModifiedDates = false;
  vm.showScanInfo = false;
  vm.showDefaultValue = false;
  vm.languages = [];
  vm.allLanguages = [];
  vm.translations = [];

  vm.selectedLanguages = localStorageService.get('TranslationToolLanguages') || ['nl'];

  vm.addLanguage = function(lang) {
    if (!lang) return;
    vm.selectedLanguages.push(lang);
    localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
    vm.filterLanguages();
    vm.getTranslations([lang]);
  };

  vm.removeLanguage = function(lang) {
    if (!lang) return;
    var idx = vm.selectedLanguages.indexOf(lang);
    if (idx >= 0) {
      vm.selectedLanguages.splice(idx, 1);
      localStorageService.set('TranslationToolLanguages', vm.selectedLanguages);
      vm.filterLanguages();
    }
  };

  vm.filterLanguages = function() {
    vm.languages = vm.allLanguages.filter(function(lang) {
      return vm.selectedLanguages.indexOf(lang) < 0;
    });
  };
  vm.filterTranslations = function(item) {
    if (vm.showNotScanned) {
      if (item.source || item.lastScanned) return false;
    }
    if (vm.fInvalidKeys) {
      return vm.containsLineEnd(item.key);
    }
    if (vm.fNotTranslated) {
      for (var i = 0; i < vm.selectedLanguages.length; i++) {
        var trans = item[vm.selectedLanguages[i]];
        if (!trans) return false;
        if (!(trans.value || trans.inherited)) return true;
      }
      return false;
    }

    return true;
  };

  vm.getTranslations = function(languages) {
    if (!languages || !languages.length) return;
    return translateSvc.getLabels(languages).then(function(data) {
      if (vm.translations.length) {
        for (var i = 0; i < data.length; i++) {
          var group = data[i];
          var translation = vm.translations.find(function(x) {
            return x.key === group.key;
          });
          if (!translation) {
            translation = {
              key: group.key,
              lastScanned: group.lastScanned,
              source: group.source,
              defaultValue: group.defaultValue,
            };
            vm.translations.push(translation);
          }
          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);
        }
      } else {
        vm.translations = data.map(function(group) {
          var translation = {
            key: group.key,
            lastScanned: group.lastScanned,
            source: group.source,
            defaultValue: group.defaultValue,
          };

          if (group.translations)
            //Map translation object directly onto parent object
            angular.extend(translation, group.translations);

          return translation;
        });
      }
    });
  };

  vm.reloadTranslations = function() {
    vm.translations = [];
    vm.getTranslations(vm.selectedLanguages);
  };

  vm.addKey = function() {
    var key = (vm.search || prompt('New key:')).trim();
    if (key) {
      for (var i = 0; i < vm.translations.length; i++) if (vm.translations[i].key === key) return;

      var translation = {
        key: key,
        lastScanned: null,
        source: null,
      };
      for (var j = 0; j < vm.selectedLanguages.length; j++)
        translations[vm.selectedLanguages[j]] = {
          value: null,
          inherited: null,
          lastModified: null,
        };

      vm.translations.push(translation);
    }
  };

  vm.save = function(item, lang, value) {
    translateSvc.saveLabel(lang, item.key, value, 1);
  };

  vm.removeTranslation = function(item) {
    translateSvc.removeLabel(item.key, 1).then(function() {
      var idx = vm.translations.findIndex(function(x) {
        return x.key === item.key;
      });
      if (idx >= 0) vm.translations.splice(idx, 1);
    });
  };
  vm.containsLineEnd = function(value) {
    if (!value || typeof value !== 'string') return false;
    return /\r|\n/.exec(value);
  };

  vm.predicate = 'key';
  vm.reverse = false;
  vm.sort = function(predicate) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;
  };
  vm.allLanguages = translateSvc.languages;
  vm.filterLanguages();
  vm.reloadTranslations();
}
